module.exports = __webpack_public_path__ + "static/img/Coconut.321f392.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Coconut.jpg
// module id = k4nL
// module chunks = 0